import type { FacetViewProps } from "@elastic/react-search-ui-views";
import { Checkbox, FilterWrapper } from "components/common/elastic/style";
import { appendClassName } from "utils";

const FIVE_CHAR_LENGTH = "5";

// This component is used to hide codes whose length is 5 (without considering punctuation)
// This can very likely be done in a much better manner if we used integer datatypes in
// elasticsearch and custom filtering without the enterprise search API.
const HideFiveCharFacet = ({
  className,
  label,
  options,
  onChange,
  values
}: FacetViewProps) => {
  const allOptionValues = options.map((option) => option.value as string);
  const fiveCharOptions = options.find(
    (option) => option.value === FIVE_CHAR_LENGTH
  );
  const isFiveCharHidden =
    values.length > 0 && !values.includes(FIVE_CHAR_LENGTH);

  const isDisabled = !fiveCharOptions || allOptionValues.length === 0;
  const isChecked = !isDisabled && isFiveCharHidden;

  const handleToggle = () => {
    if (isFiveCharHidden) {
      onChange(allOptionValues);
    } else {
      onChange(allOptionValues.filter((value) => value !== FIVE_CHAR_LENGTH));
    }
  };

  return (
    <FilterWrapper className={appendClassName(className)}>
      <Checkbox
        type="checkbox"
        label={label}
        id={`facet-${label}`}
        name={`facet-${label}`}
        disabled={isDisabled}
        checked={isChecked}
        onChange={handleToggle}
        style={{ fontWeight: isChecked ? "bold" : "normal" }}
      />
    </FilterWrapper>
  );
};

export default HideFiveCharFacet;
